import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/index.js'
import VueCookies from 'vue-cookies'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: resolve => require(['@/views/Dashboard.vue'], resolve),
      meta: { title: 'Dashboard' }
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['@/views/Login.vue'], resolve),
      meta: {
        layout: 'layoutLogin',
        title: 'Login'
      }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: resolve => require(['@/views/Forgot.vue'], resolve),
      meta: {
        layout: 'layoutLogin',
        title: 'Reset Password'
      }
    },
    {
      name: 'reset',
      path: '/reset/:id',
      component: resolve => require(['@/views/Reset.vue'], resolve),
      meta: {
        layout: 'layoutLogin',
        title: 'Reset Password'
      }
    },
    {
      path: '/register-company',
      name: 'register-company',
      component: resolve => require(['@/views/Register.vue'], resolve),
      meta: {
        layout: 'layoutLogin',
        title: 'Sign Up'
      }
    },
    {
      path: '/signup/:id',
      name: 'signup',
      component: resolve => require(['@/views/RegisterInvitation.vue'], resolve),
      meta: {
        layout: 'layoutLogin',
        title: 'Sign Up Invitation'
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: resolve => require(['@/views/Dashboard.vue'], resolve),
      meta: { title: 'Dashboard' }
    },
    {
      path: '/schools',
      component: resolve => require(['@/views/schools/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/schools/index.vue'], resolve),
          meta: { title: 'Schools' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/schools/create.vue'], resolve),
          meta: { title: 'Add School' }
        },
        {
          name: 'edit-school',
          path: 'edit/:id',
          component: resolve => require(['@/views/schools/edit.vue'], resolve),
          meta: { title: 'Edit School' }
        }
      ]
    },
    {
      path: '/expenses',
      component: resolve => require(['@/views/expenses/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/expenses/index.vue'], resolve),
          meta: { title: 'Schools' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/expenses/create.vue'], resolve),
          meta: { title: 'Add Expense' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('create_expense') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          name: 'edit-expense',
          path: 'edit/:id',
          component: resolve => require(['@/views/expenses/edit.vue'], resolve),
          meta: { title: 'Edit Expense' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('edit_expense') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          path: 'approve',
          component: resolve => require(['@/views/expenses/approve.vue'], resolve),
          meta: { title: 'Approve Expense' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('approve_expense') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        }
      ]
    },
    {
      path: '/class-types',
      component: resolve => require(['@/views/class-types/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/class-types/index.vue'], resolve),
          meta: { title: 'Class Types' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/class-types/create.vue'], resolve),
          meta: { title: 'Add Class Type' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('create_class_type') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          name: 'edit-class-type',
          path: 'edit/:id',
          component: resolve => require(['@/views/class-types/edit.vue'], resolve),
          meta: { title: 'Edit Class Type' },
          props: true,
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('edit_class_type') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        }
      ]
    },
    {
      path: '/classes',
      component: resolve => require(['@/views/classes/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/classes/index.vue'], resolve),
          meta: { title: 'Classes' }
        },
        {
          path: 'calendar',
          component: resolve => require(['@/views/classes/calendar.vue'], resolve),
          meta: { title: 'Classes' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/classes/create.vue'], resolve),
          meta: { title: 'Add Class' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('create_class') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          name: 'edit-class',
          path: 'edit/:id',
          component: resolve => require(['@/views/classes/edit.vue'], resolve),
          meta: { title: 'Edit Class' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('edit_class') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        }
      ]
    },
    {
      path: '/settings',
      component: resolve => require(['@/views/settings/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/settings/company-settings.vue'], resolve),
          meta: { title: 'Company Settings' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('company_management') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          path: 'profile',
          component: resolve => require(['@/views/settings/profile.vue'], resolve),
          meta: { title: 'Profile' }
        },
        {
          path: 'create-location',
          component: resolve => require(['@/views/location/create.vue'], resolve),
          meta: { title: 'Add Location' }
        },
        {
          name: 'edit-location',
          path: 'edit-location/:id',
          component: resolve => require(['@/views/location/edit.vue'], resolve),
          meta: { title: 'Edit Location' },
          props: true
        },
        {
          path: 'create-invoicing-term-codition',
          component: resolve => require(['@/views/invoice-tc/create.vue'], resolve),
          meta: { title: 'Add Lesson Type' }
        },
        {
          name: 'edit-invoicing-term-codition',
          path: 'edit-invoicing-term-codition/:id',
          component: resolve => require(['@/views/invoice-tc/edit.vue'], resolve),
          meta: { title: 'Edit Lesson type' },
          props: true
        },
        {
          path: 'email-settings',
          component: resolve => require(['@/views/email-settings/create.vue'], resolve),
          meta: { title: 'Email Settings' }
        }
      ]
    },
    {
      path: '/clients',
      component: resolve => require(['@/views/Clients/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/Clients/index.vue'], resolve),
          meta: { title: 'Clients' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/Clients/create.vue'], resolve),
          meta: { title: 'Create Client' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('create_client') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          path: 'edit/:id',
          name: 'edit-client',
          component: resolve => require(['@/views/Clients/edit.vue'], resolve),
          props: true,
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('edit_client') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        }
      ]
    },
    {
      path: '/teacher-directory',
      component: resolve => require(['@/views/users/teacher-directory.vue'], resolve)
    },
    {
      path: '/users',
      component: resolve => require(['@/views/users/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/users/index.vue'], resolve),
          meta: { title: 'Users' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/users/create.vue'], resolve),
          meta: { title: 'Create User' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('create_user') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          path: 'teacher',
          component: resolve => require(['@/views/users/teacher.vue'], resolve),
          meta: { title: 'List of Teachers' }
        },
        {
          path: 'edit/:id',
          name: 'edit-user',
          component: resolve => require(['@/views/users/edit.vue'], resolve),
          props: true,
          meta: { title: 'Edit User' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('edit_user') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        }
      ]
    },
    {
      path: '/student-lessons',
      component: resolve => require(['@/views/student-lessons/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/student-lessons/index.vue'], resolve),
          meta: { title: 'Student Lessons' }
        },
        {
          name: 'add-student-lesson',
          path: 'create/:id',
          component: resolve => require(['@/views/student-lessons/create.vue'], resolve),
          meta: { title: 'Add Student Lessons' },
          props: true
        },
        {
          name: 'edit-student-lessons',
          path: 'edit/:id',
          component: resolve => require(['@/views/student-lessons/edit.vue'], resolve),
          meta: { title: 'Edit Student Lessons' },
          props: true
        }
      ]
    },
    {
      path: '/reports',
      component: resolve => require(['@/views/reports/template.vue'], resolve),
      children: [
        {
          path: 'teacher',
          component: resolve => require(['@/views/reports/teacher/index.vue'], resolve),
          meta: { title: 'Teacher Reports' }
        },
        {
          path: 'student',
          component: resolve => require(['@/views/reports/student/index.vue'], resolve),
          meta: { title: 'Student Reports' }
        },
        {
          path: 'revenue',
          component: resolve => require(['@/views/reports/revenue/index.vue'], resolve),
          meta: { title: 'Revenue Report' }
          // beforeEnter: (to, from, next) => {
          //   if (store.getters.permissions.indexOf('create_teacher_salary') >= 0) {
          //     next()
          //   } else {
          //     next({ path: 'not-found' })
          //   }
          // }
        },
        {
          path: 'expense',
          component: resolve => require(['@/views/reports/expense/index.vue'], resolve),
          meta: { title: 'Expense Report' }
          // beforeEnter: (to, from, next) => {
          //   if (store.getters.permissions.indexOf('create_teacher_salary') >= 0) {
          //     next()
          //   } else {
          //     next({ path: 'not-found' })
          //   }
          // }
        }
      ]
    },
    {
      path: '/teacher-salary',
      component: resolve => require(['@/views/invoices/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/reports/teacher-salary/index.vue'], resolve),
          meta: { title: 'Teacher Salary List' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/reports/teacher-salary/create.vue'], resolve),
          meta: { title: 'Create Teacher Salary' }
        },
        {
          name: 'edit-teacher-salary',
          path: 'edit/:id',
          component: resolve => require(['@/views/reports/teacher-salary/edit.vue'], resolve),
          meta: { title: 'Edit Teacher Salary' },
          props: true
        }
      ]
    },
    {
      path: '/invoices',
      component: resolve => require(['@/views/invoices/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/invoices/index.vue'], resolve),
          meta: { title: 'List of Invoices' }
        },
        {
          path: 'edit/:id',
          name: 'edit-invoice',
          component: resolve => require(['@/views/invoices/edit.vue'], resolve),
          props: true,
          meta: { title: 'Edit Invoice' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('edit_invoice') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        },
        {
          path: '/invoices/create',
          component: resolve => require(['@/views/invoices/create.vue'], resolve),
          meta: { title: 'Generate Invoice' },
          beforeEnter: (to, from, next) => {
            if (store.getters.permissions.indexOf('create_invoice') >= 0) {
              next()
            } else {
              next({ path: 'not-found' })
            }
          }
        }
      ]
    },
    {
      path: '/credit-notes',
      component: resolve => require(['@/views/credit-notes/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/credit-notes/index.vue'], resolve),
          meta: { title: 'Credit Notes' }
        },
        {
          path: 'edit/:id',
          name: 'edit-credit-note',
          component: resolve => require(['@/views/credit-notes/edit.vue'], resolve),
          props: true,
          meta: { title: 'Edit Credit Note' }
        },
        {
          path: '/credit-notes/create',
          component: resolve => require(['@/views/credit-notes/create.vue'], resolve),
          meta: { title: 'Create Credit Note' }
        }
      ],
      beforeEnter: (to, from, next) => {
        if (store.getters.permissions.indexOf('company_management') >= 0) {
          next()
        } else {
          next({ path: 'not-found' })
        }
      }
    },
    {
      path: '/tags',
      component: resolve => require(['@/views/tags/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/tags/index.vue'], resolve),
          meta: { title: 'Tags' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/tags/create.vue'], resolve),
          meta: { title: 'Add Tag' }
        },
        {
          name: 'edit-tag',
          path: 'edit/:id',
          component: resolve => require(['@/views/tags/edit.vue'], resolve),
          meta: { title: 'Edit Tag' }
        }
      ]
    },
    {
      path: '/quotes',
      component: resolve => require(['@/views/quotes/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/quotes/index.vue'], resolve),
          meta: { title: 'List of Quotes' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/quotes/create.vue'], resolve),
          meta: { title: 'Create Quote' }
        },
        {
          path: 'edit/:id',
          name: 'edit-quote',
          component: resolve => require(['@/views/quotes/edit.vue'], resolve),
          props: true,
          meta: { title: 'Edit Quote' }
        }
      ]
    },
    {
      path: '/documents',
      component: resolve => require(['@/views/documents/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/documents/index.vue'], resolve),
          meta: { title: 'Documents' }
        },
        {
          path: 'create',
          component: resolve => require(['@/views/documents/create.vue'], resolve),
          meta: { title: 'Add Document' }
        },
        {
          name: 'edit-document',
          path: 'edit/:id',
          component: resolve => require(['@/views/documents/edit.vue'], resolve),
          meta: { title: 'Edit Document' }
        }
      ]
    },
    {
      path: '/knowledge',
      component: resolve => require(['@/views/knowledge/template.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['@/views/knowledge/index.vue'], resolve),
          meta: { title: 'Documents' }
        }
      ]
    },
    {
      path: '*',
      component: resolve => require(['@/views/404.vue'], resolve),
      meta: { title: 'Not Found' }
    }
  ]
})

// protect routes. Allow user which are logged in
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (VueCookies.isKey('token')) {
    if (!store.getters.isLoggedIn) {
      if (to.path === '/login' || to.path === '/register-company' || to.name === 'signup' || to.path === '/reset-password' || to.name === 'reset') {
        next()
      } else {
        next({ path: '/login' })
      }
    } else {
      if (to.path === '/login' || to.path === '/register-company' || to.name === 'signup' || to.path === '/reset-password' || to.name === 'reset') {
        next({ path: '/' })
      } else {
        next()
      }
    }
  } else {
    if (to.path === '/login' || to.path === '/register-company' || to.name === 'signup' || to.path === '/reset-password' || to.name === 'reset') {
      next()
    } else {
      next({ path: '/login' })
    }
  }

  document.title = (to.meta.title) ? 'OptimClass - ' + to.meta.title : 'OptimClass'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js